import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', function () {
    const lightbox = GLightbox({
        selector: '.glightbox'
    });
});